import React, { forwardRef, LegacyRef } from 'react'
import { RedMarkedTextProps } from './RedMarkedText.types'
import styles from './RedMarkedText.module.scss'
import cl from 'classnames'

const RedMarkedTextComponent = (props: RedMarkedTextProps, ref: LegacyRef<HTMLDivElement>) => {
  const {
    className,
    style,
    children
  } = props

  if (typeof children === 'object' && children !== null) {
    return null
  }

  return (
    <div
      ref={ref}
      className={cl(styles.valueBeforeChange, className)}
      style={style}
    >
      {children}
    </div>
  )
}

const RedMarkedText = forwardRef(RedMarkedTextComponent)
export { RedMarkedText }
